export default "__VITE_ASSET__Dnn4WAhm__"